import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { EDIT_QUESTION } from './constants';
import {
  EditQuestionDataActionTypes,
  EditQuestionError,
  EditQuestionState,
  EditQuestionSuccess,
} from './types';

const initialState: EditQuestionState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: EditQuestionDataActionTypes,
  ): EditQuestionState => {
    switch (action.type) {
      case EDIT_QUESTION + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case EDIT_QUESTION + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as EditQuestionSuccess).payload;
        break;
      }
      case EDIT_QUESTION + FAILURE: {
        draft.status = rejected;
        draft.error = (action as EditQuestionError).error;
        break;
      }
      case EDIT_QUESTION + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
